import { ACCOUNT_CREATED_COOKIE_NAME } from '../analytics/account-created-cookie';

const SHOWN_KEY = 'jc-post-signup-alert-nudge-shown';

function readCookieValue(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * TEC-514 #5: whether the post-signup value-prop nudge should fire. True exactly once, right
 * after a first-ever login this browser hasn't already been nudged for. Reads the same
 * short-lived `jc_account_created` cookie the analytics conversion signal reads
 * (utils/analytics/account-created-signal.ts), non-destructively; this never clears it, that
 * stays that module's job. It remembers "already shown" in its own permanent flag so the
 * nudge fires once ever per browser, not once per page load within the cookie's ~10-minute TTL
 * (account-created-signal.ts only clears the cookie once its own analytics event actually
 * fires, which can be delayed or blocked by consent; this flag doesn't depend on that at all).
 */
export function shouldShowPostSignupNudge(): boolean {
  try {
    if (localStorage.getItem(SHOWN_KEY) === '1') {
      return false;
    }
  } catch {
    return false;
  }
  return readCookieValue(ACCOUNT_CREATED_COOKIE_NAME) === '1';
}

export function markPostSignupNudgeShown(): void {
  try {
    localStorage.setItem(SHOWN_KEY, '1');
  } catch {
    // Best effort only.
  }
}
